import React from 'react';

import { Tooltip } from 'antd';
import { UnorderedListOutlined } from '@ant-design/icons';

import { IToolbarCommand } from '../../../../../../../models/Shopping';

const CommandListView: React.FunctionComponent<IToolbarCommand> = ({ disabled, action }) => {
    const _handleCommandAction = () => {
        if (disabled || !action) {
            return;
        }

        action();
    }

    return (
        <div className={`command ${disabled && 'command-disabled'}`} onClick={_handleCommandAction}>
            <Tooltip title="List view">
                <UnorderedListOutlined />
            </Tooltip>
        </div>
    );
}

export default CommandListView;